import React, { useCallback, useEffect, useRef, useState } from "react";
import { columns, filters, searchBy } from "../../../service/AUCategoryService";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";
import StoreModal from "../../../Components/Modals/StoreModal/StoreModal";
import ReferralModal from "../../PromotionManagement/Refferal/ReferralModal";
import MenuApi from "../../../App/api/menu.apis";
import { ApproveUnapproveApi } from "../../../App/api/a&uApi";
import { toast } from "react-toastify";
import CustomModal from "../../../custom/modal/customModal";
import CommonRejectTemplate from "../../../Components/CommonRejectTemplate";
import AUCategoryMadal from "./AUCategoryModal";
import { approvalStatusApi } from "../../../App/api/multilevelApproval.api";

const AUCategoryComponent = ({ pagination, handlePagination }) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [isOrderDetail, setIsOrderDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [vendorData, setVendorData] = useState(null);
  const [categoryData, setPromocodeData] = useState(null);
  const [actionData, setActionData] = useState(null);
  const [isRejectCategoryModalOpen, setIsRejectCategoryModalOpen] =
    useState(false);
  const [showSidebarModal, setShowSidebarModal] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState(null);

  const getAllCategory = async () => {
    try {
      const res = await MenuApi.getVenderCategory(pagination, search);
      setPromocodeData(res?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }

    try {
      const approvalStatus = await approvalStatusApi.getAllApprovalStatuses({
        filter: { component: "Category" },
      });
      setApprovalStatus(approvalStatus?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const handleCloseOrderModal = () => {
    setIsOrderDetail(false);
    setSelectedOrder(null);
  };
  const handleRowClick = (row) => {
    setSelectedOrder(row);
    setIsOrderDetail(true);
  };
  const handleCellClick = async (row, action) => {
    if (action === "Rejected") {
      setIsRejectCategoryModalOpen(true);
      setSelectedOrder(row);
      setActionData(action);
    } else if (action === "Approved") {
      setSelectedOrder(row);
      setActionData(action);
      setShowSidebarModal(true);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllCategory();
  }, [pagination, search]);

  return (
    <div className="p-5">
      <BasicTable
        columns={columns}
        data={categoryData?.categories}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: categoryData?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: categoryData?.totalPages || 1,
          totalCount: categoryData?.totalCount || 1,
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        filters={filters}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
      />
      <AUCategoryMadal
        approve="Approve"
        currentItems={selectedOrder}
        actionData={actionData}
        approvalStatus={approvalStatus}
        open={showSidebarModal}
        setShowSidebarModal={setShowSidebarModal}
        getAllCategory={getAllCategory}
        handleClose={() => {
          setShowSidebarModal(false);
          getAllCategory();
        }}
      />
      <CustomModal
        isOpen={isRejectCategoryModalOpen}
        onClose={() => setIsRejectCategoryModalOpen(false)}
        title="Reject Category"
      >
        <CommonRejectTemplate
          data={selectedOrder}
          name={selectedOrder?.name}
          actionData={actionData}
          getAllData={getAllCategory}
          endpoint={ApproveUnapproveApi.updateCategoryApprovalStatus}
          closeModal={setIsRejectCategoryModalOpen}
          component="Category"
          approvalStatus={approvalStatus}
        />{" "}
      </CustomModal>
    </div>
  );
};

export default AUCategoryComponent;
